import React, { useEffect } from "react";
import styles from "../../components.module.css";
import FieldHeader from "../FieldHeader";

function TextInput({ parameters, value, onChange }) {
  useEffect(() => {
    if (
      parameters.default &&
      JSON.stringify(parameters.default) === JSON.stringify(value)
    ) {
      onChange(
        typeof parameters.default === "object"
          ? JSON.stringify(parameters.default)
          : parameters.default
      );
    }
  }, []);

  return (
    <div className={styles.form_control}>
      <FieldHeader
        label={parameters.label}
        description={parameters.description}
      />
      <input
        value={value || ""}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        placeholder={parameters.placeholder}
      />
    </div>
  );
}

export default TextInput;
